import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: 'Quick Links',
    links: [
      { label: 'Home', to: '/' },
      { label: 'Complete Guide', to: '/article/sugargoo-spreadsheet-complete-guide' },
    ],
  },
  {
    title: 'External Resources',
    links: [
      { label: 'Sugargoo Spreadsheet', href: 'https://kaspreadsheet.com', external: true },
      { label: 'Buy It Now', href: 'https://kaspreadsheet.com', external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-950 text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-database-2-line text-base text-white"></i>
              </div>
              <span className="font-heading font-semibold text-white text-base whitespace-nowrap">
                Sugargoo <span className="text-primary-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs">
              The ultimate product research database and shopping guide. Helping shoppers discover, compare, and organize their Sugargoo finds since 2026.
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {('to' in link) ? (
                      <Link to={link.to} className="text-sm text-foreground-300 hover:text-white transition-colors">
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-300 hover:text-white transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 Sugargoo Spreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-foreground-500">
            This is an independent informational resource. We are not affiliated with Sugargoo.
          </p>
        </div>
      </div>
    </footer>
  );
}